export default __webpack_public_path__ + "static/pizza-64601fe6ec68ed61b0336a776a15c0fe.png";